export const convertBase64StringToImageData = (buffer, width, height) => {
	return new Promise((resolve) => {
		var image = new Image();

		image.addEventListener('load', function (e) {
			var canvasElement = document.createElement('canvas');

			canvasElement.width = width;
			canvasElement.height = height;

			var context = canvasElement.getContext('2d');
			context.drawImage(e.target, 0, 0, width, height);

			resolve(context.getImageData(0, 0, width, height));
		});

		image.src = buffer;
		image.hidden = true;

		document.body.appendChild(image);

		setTimeout(() => {
			document.body.removeChild(image);
		}, 0);
	});
};
